export default function PayrollStepper({ currentStep, steps }) {
  const visibleSteps = steps || ["Period", "Process", "Exceptions", "Generate"];

  return (
    <div className="mb-8 flex items-center justify-between">
      {visibleSteps.map((step, index) => {
        const active = currentStep >= index + 1;

        return (
          <div key={step} className="flex flex-1 items-center">
            <div className="flex items-center">
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-2xl text-sm font-semibold transition-all ${
                  active
                    ? "bg-primary-700 text-white"
                    : "bg-gray-100 text-gray-500"
                }`}
              >
                {index + 1}
              </div>

              <span
                className={`ml-3 font-medium ${
                  active ? "text-gray-900" : "text-gray-400"
                }`}
              >
                {step}
              </span>
            </div>

            {index < visibleSteps.length - 1 ? (
              <div
                className={`mx-4 h-0.5 flex-1 ${
                  currentStep > index + 1 ? "bg-primary-700" : "bg-gray-200"
                }`}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
